// Small display helpers for AI voice metadata, in a plain module (not a
// component file) so both VoiceSelect and VoiceAuditionPanel can import them
// without tripping React Fast Refresh's component-only-export rule.

const PROVIDER_LABELS: Record<string, string> = {
  elevenlabs: 'ElevenLabs',
  openai: 'OpenAI',
};

/** Human-facing provider name, e.g. `elevenlabs` → `ElevenLabs`. */
export function providerLabel(provider: string): string {
  return PROVIDER_LABELS[provider] ?? provider;
}

/** Title-cased gender, or null when unknown. */
export function genderLabel(gender?: string | null): string | null {
  if (!gender) return null;
  return gender.charAt(0).toUpperCase() + gender.slice(1);
}

/**
 * The secondary voice descriptor shown under/after the name across the AI Voice
 * surfaces — e.g. `Male · ElevenLabs` (gender first; omitted when unknown).
 */
export function voiceMeta(provider: string, gender?: string | null): string {
  const g = genderLabel(gender);
  return g ? `${g} · ${providerLabel(provider)}` : providerLabel(provider);
}

/**
 * Avatar initials for a voice name — up to two letters, ignoring parenthetical
 * qualifiers so "Brian (Deep & Resonant)" → "B", "Charles Pestel" → "CP".
 */
export function voiceInitials(name: string): string {
  return name
    .replace(/\([^)]*\)/g, ' ') // drop "(Deep & Resonant)" style qualifiers
    .split(/\s+/)
    .filter(w => /^[A-Za-z0-9]/.test(w))
    .slice(0, 2)
    .map(w => w[0].toUpperCase())
    .join('');
}
